import { createStore } from "vuex";

interface AppState {
  darkMode: boolean;
}

export default createStore({
  state: {
    darkMode: true,
  },
  getters: {},
  mutations: {
    toggleDarkMode(state: AppState) {
      state.darkMode = !state.darkMode;
      if (state.darkMode === false) {
        document.getElementById("app")?.classList.add("light");
      } else {
        document.getElementById("app")?.classList.remove("light");
      }
    },
  },
  actions: {},
  modules: {},
});
